import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoDrive = () => {
  return (
    <g>
      <path d="m15.258 9.786h-4.726l-4.887-8.466h4.726z" />
      <path d="m4.038 14.68 2.35-4.129h9.163l-2.351 4.129z" />
      <path d="m2.817 14.603-2.368-4.123 4.523-8.11 2.405 4.235z" />
    </g>
  );
};

export default withIcon(IconLogoDrive);
